import { VehicleType } from "../enums/vehicle-type.enum";

export const VehicleTypeTranslations: Record<VehicleType, string> = {
    [VehicleType.TURISMO]: 'tourism',
    [VehicleType.MONOVOLUMEN]: 'minivan',
    [VehicleType.TODOTERRENO]: 'atv',
    [VehicleType.SUV]: 'suv',
    [VehicleType.COUPE]: 'coupe',
  };
  
  
